import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { StoragePort } from '@app/common/storage/application/ports/storage.port';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService implements StoragePort {
    public setItem(key: string, value: string): Observable<void> {
        const storage: Storage | null = this.getStorage();

        if (!storage) {
            return of(undefined);
        }

        try {
            storage.setItem(key, value);
        } catch {
            return of(undefined);
        }

        return of(undefined);
    }

    public getItem(key: string): Observable<string | null> {
        const storage: Storage | null = this.getStorage();

        if (!storage) {
            return of(null);
        }

        try {
            return of(storage.getItem(key));
        } catch {
            return of(null);
        }
    }

    public removeItem(key: string): Observable<void> {
        const storage: Storage | null = this.getStorage();

        if (!storage) {
            return of(undefined);
        }

        try {
            storage.removeItem(key);
        } catch {
            return of(undefined);
        }

        return of(undefined);
    }

    public clear(): Observable<void> {
        const storage: Storage | null = this.getStorage();

        if (!storage) {
            return of(undefined);
        }

        try {
            storage.clear();
        } catch {
            return of(undefined);
        }

        return of(undefined);
    }

    private getStorage(): Storage | null {
        try {
            if (typeof window === 'undefined' || !window.localStorage) {
                return null;
            }

            return window.localStorage;
        } catch {
            return null;
        }
    }
}
